import { render } from "./ManageNewIntegrations.vue?vue&type=template&id=1c688b32"
import script from "./ManageNewIntegrations.vue?vue&type=script&lang=js"
export * from "./ManageNewIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__